import React, { useState } from "react";
import handleChange from "../../hooks/handleChange";
import "./NewPasswordForm.scss";
import { setFirstLoginPIN, setFirstLoginPassword } from "../../util/API/customers";
import CheckMark from "../../images/ic_round-check.svg";
import { Box, TextField, Breadcrumbs, Link, Typography, IconButton } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function NewPasswordForm({ toggleReset, userName, userid, resetPIN }) {
  const [password, setPassword, resetPassword] = handleChange("");
  const [password2, setPassword2, resetPassword2] = handleChange("");
  const [error, setError] = useState(null);
  const [displayError, setDisplayError] = useState(false);
  const [changeSuccuess, setChangeSuccuess] = useState(false);
  const [pinChange, setPinChange] = useState(false)
  const [pin, setPin] = useState({
    oldpin: ["", "", "", ""],
    pin: ["", "", "", ""],
    confirmpin: ["", "", "", ""],
    passwordoldpin: ["", "", "", ""],
  });
  const [visible, setVisible] = useState({
    password: false,
    confirmPassword: false,
    pin: false,
    confirmpin: false,
    oldpin: false
  });
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
    header: "Success"
  });

  function validatePassword(str) {
    const hasNumber = /\d/.test(str); // Checks for a digit
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(str); // Checks for special characters
    const isEightOrMoreChars = str.length >= 8; // Checks if length is 8 or more
    return hasNumber && hasSpecialChar && isEightOrMoreChars;
  }

  async function handleFormSubmit(e) {
    setDisplayError(false);
    e.preventDefault();

    //checks if the password is valid
    if (validatePassword(password)) {
      //checks if the password matches
      if (password == password2) {
        const response = await setFirstLoginPassword(password, userName, pin.passwordoldpin.join(''));

        if (response?.callStatus === "1") {
          setChangeSuccuess(true);
        } else {
          let responseError = response?.payload?.msg;
          setDisplayError(true);
          setError(responseError);
          setAlert({ 
            showAlert: true, 
            severity: "error",
            header: "Error",
            message: responseError
          });
        }

      } else {
        setDisplayError(true);
        setError("Password Does Not Match - Try Again");
        setAlert({ 
          showAlert: true, 
          severity: "error",
          header: "Error",
          message: "Password Does Not Match - Try Again"
        });
      }
    } else {
      setDisplayError(true);
      setError(
        "The password must contain a digit, a special character, and be at least 8 characters long"
      );
      setAlert({
        showAlert: true, 
        severity: "error",
        header: "Error",
        message: "The password must contain a digit, a special character, and be at least 8 characters long"
      });
    }
  }

  async function handlePINFormSubmit(e) {
    setDisplayError(false);
    e.preventDefault();
    //checks if the password is valid
    if (pin.pin.join('') === pin.confirmpin.join('')) 
    // if (pin.pin == pin.confirmpin) 
    {
      const response2 = await setFirstLoginPIN(userName, pin.pin.join(''), pin.oldpin.join(''), userid);
      //If we get a callstatus, it has passed
      if (response2.callStatus) {
        setPinChange(true)
      } else {
        let responseError = response2.payload.msg;
        setDisplayError(true);
        setError(responseError);
        setAlert({
          showAlert: true, 
          severity: "error",
          header: "Error",
          message: responseError
        });
      }
    } else {
      setDisplayError(true);
      setError(
        "PIN Does Not Match - Try Again"
      );
      setAlert({
        showAlert: true, 
        severity: "error",
        header: "Error",
        message: "PIN Does Not Match - Try Again"
      });
    }
  }

  const handleClick = (e, path) => {
    e.preventDefault();
    if (path === "/reset-password") {
      setPinChange(false)
    } else if (path === "/reset-pin") {
      setPinChange(true)
    }
  };

  const toggleVisibility = (key) => {
    setVisible((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handlePINChange = (value, index, key) => {
    if (isNaN(value)) return; // Allow only numeric input
    setPin((prev) => {
      const updatedPin = { ...prev };
      const updatedArray = [...updatedPin[key]]; // Get the current pin array
      updatedArray[index] = value; // Update the specific digit
      updatedPin[key] = updatedArray; // Update the specific key
      return updatedPin;
    });
  
    // Move focus to the next input box
    if (value && index < pin[key].length - 1) {
      document.getElementById(`${key}-input-${index + 1}`).focus();
    }
  };

  const renderPinFields = (key, label) => (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, marginBottom: 2 }}>
      <Typography variant="caption text" sx={{ width: "100px", fontSize: "10px", color: "grey", font: "Nunito" }}>
        {label}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {pin[key].map((digit, index) => (
          <TextField
            key={index}
            id={`${key}-input-${index}`}
            value={digit}
            onChange={(e) => handlePINChange(e.target.value, index, key)}
            onKeyDown={(e) => handleBackspace(e, index)}
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: "20px",
                padding: "10px",
              },
            }}
            type={visible[key] ? "text" : "password"}
            variant="outlined"
            sx={{
              width: "50px",
              height: "50px",
              "& .MuiOutlinedInput-root": {
                padding: 0,
              },
            }}
          />
        ))}
        <IconButton onClick={() => toggleVisibility(key)}>
          {visible[key] ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </Box>
    </Box>
  );

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && pin[index] === "" && index > 0) {
      document.getElementById(`pin-input-${index - 1}`).focus();
    }
  };

  // console.log(pin)

  return (
    <Box>
      {changeSuccuess ? (
        <Box className="login-label d-flex gap-2 ">
          <Box>Your password and pin have been successfully reset.</Box>
          <img src={CheckMark} loading="lazy" />
        </Box>
      ) : (
        <Box className="d-flex gap-5 align-items-center mb-4">

          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >

          {pinChange && resetPIN ? (
            <Link
              underline="always"
              color="inherit"
              href="#"
              onClick={(e) => handleClick(e, "/reset-password")}
              sx={{ fontSize: "14px", fontWeight: 500 }}
            >
              Reset PIN
            </Link>
          ) : resetPIN ? (
            <Typography
              color="textPrimary"
              sx={{ fontSize: "14px", fontWeight: 500 }}
            >
              Reset PIN
            </Typography>
          ) : null}

          {changeSuccuess ? (
            <Link
              underline="hover"
              color="inherit"
              href="#"
              onClick={(e) => handleClick(e, "/reset-pin")}
              sx={{ fontSize: "14px", fontWeight: 500 }}
            >
              Reset Password
            </Link>
          ) : (
            <Typography
              color="textPrimary"
              sx={{ fontSize: "14px", fontWeight: 500 }}
            >
              Reset Password
            </Typography>
          )}

          <Typography color="textPrimary" sx={{ fontSize: "14px", fontWeight: 500 }}>
            Verified
          </Typography>
        </Breadcrumbs>

          {displayError && changeSuccuess &&  <Box className="error-password-text">{error}</Box>}
        </Box>
      )}

      {changeSuccuess ? (
        <Box className="sign-in-here-text pointer" onClick={toggleReset}>
          Sign-In Here
        </Box>
      // ):
      ) : !pinChange && resetPIN ? (
        <>
          <Box className="reset-email-account">{userName}</Box>

          <form onSubmit={handlePINFormSubmit}>
            <Box>

            {renderPinFields("oldpin", "Old PIN")}
            {renderPinFields("pin", "New PIN")}
            {renderPinFields("confirmpin", "Confirm PIN")}

            </Box>
            <Box></Box>

            <Box className="login-button-container">
              <Box className="sign-in-here-text pointer" onClick={toggleReset}>
                Go Back
              </Box>
              <Box></Box>
              <Box>
                <button className="send-password-button">RESET PIN</button>
              </Box>
            </Box>
          </form>
        </>
      ) :
      (
        <>
          <Box className="reset-email-account">{userName}</Box>

          <form onSubmit={handleFormSubmit}>
            <Box>
              <TextField
                className="login-input"
                label="Enter New Password"
                name="username"
                value={password}
                onChange={setPassword}
                type={visible.password ? "text" : "password"}
              />
              <span onClick={() => setVisible({...visible, password: !visible.password})} className="visible-icon">
                {visible["password"] ? <VisibilityOff /> : <Visibility />}
              </span>

              <TextField
                className="login-input"
                name="username"
                label="Re-Enter New Password"
                value={password2}
                onChange={setPassword2}
                // placeholder="Re-Enter New Password"
                type={visible.confirmPassword ? "text" : "password"}
                />
              <span onClick={() => setVisible({...visible, confirmPassword: !visible.confirmPassword})} className="visible-icon">
                {visible.confirmPassword ? <VisibilityOff /> : <Visibility />}
              </span>

              {renderPinFields("passwordoldpin", "Enter Newly Set PIN")}

            </Box>
            <Box></Box>

            <Box className="login-button-container">
              <Box className="sign-in-here-text pointer" onClick={toggleReset}>
                Go Back
              </Box>
              <Box></Box>
              <Box>
                <button className="send-password-button">RESET PASSWORD</button>
              </Box>
            </Box>
          </form>
        </>
      )}
      <CustomAlert
            severity={alert.severity}
            show={alert.showAlert}
            header={alert.header}
            message={alert.message}
            onClick={() => {
              setAlert((prevDetails) => ({ ...prevDetails, showAlert: false }));
            }}
            autoclose={alert.severity === "error" ? false : true}
          />
    </Box>
  );
}

export default NewPasswordForm;
